import axios from "axios";
import { SERVER } from "../../Constants";

const apiClient = axios.create({
  baseURL: SERVER,
  withCredentials: true,
});

/* ── Guidance posts ─────────────────────────────────────────────────────── */

export const getGuidancePosts = async () => {
  const res = await apiClient.get("/religious/admin/posts");
  return res.data; // { success, posts }
};

export const createGuidancePost = async (payload) => {
  const res = await apiClient.post("/religious/admin/posts", payload);
  return res.data; // { success, post }
};

export const updateGuidancePost = async (id, payload) => {
  const res = await apiClient.put(`/religious/admin/posts/${id}`, payload);
  return res.data; // { success, post }
};

export const deleteGuidancePost = async (id) => {
  const res = await apiClient.delete(`/religious/admin/posts/${id}`);
  return res.data; // { success, message }
};

/* ── Hadith ─────────────────────────────────────────────────────────────── */

export const getHadiths = async () => {
  const res = await apiClient.get("/religious/admin/hadith");
  return res.data; // { success, hadiths }
};

// Accepts an array of { arabic?, translation, reference, narrator? }.
// The server auto-assigns each hadith to the next free delivery day.
export const createHadiths = async (hadiths) => {
  const res = await apiClient.post("/religious/admin/hadith", { hadiths });
  return res.data; // { success, count, hadiths }
};

export const updateHadith = async (id, payload) => {
  const res = await apiClient.put(`/religious/admin/hadith/${id}`, payload);
  return res.data; // { success, hadith }
};

export const deleteHadith = async (id) => {
  const res = await apiClient.delete(`/religious/admin/hadith/${id}`);
  return res.data; // { success, message }
};
